import React, { useMemo } from 'react';
import { Col, Collapse } from 'react-bootstrap';
import { Switch } from '../../Input/Input';
import DocumentTypeTooltip from './DocumentTypeTooltip';
import QuantitySelect from './QuantitySelect';

const ExcludableDocumentRow = ({
  checked,
  tips,
  title,
  onChange,
  inputName,
  location,
  show,
  documentDetails,
  readOnly,
  additionalMessage,
  qty,
  onQtyChange,
  qtyDisabled = true,
}) => {
  const quantityOptions = useMemo(() => Array.from({ length: 99 }, (_, i) => ({ id: i + 1, data: String(i + 1) })), []);

  if (!show) return null;
  return (
    <div className="d-flex flex-column mb-1" style={{ backgroundColor: 'var(--eori-silver)' }}>
      <div className="d-flex gap-2 align-items-center my-3">
        <div className="align-self-start px-2 ps-4" style={{ maxWidth: '75px', minWidth: '75px' }}>
          <Switch
            checked={checked}
            onChange={onChange}
            name={inputName}
            className="d-flex gap-3 text-eoriblue"
            disabled={readOnly}
          />
        </div>
        <Col xs="2" className="d-flex ms-3" style={{ minWidth: '20rem' }}>
          <DocumentTypeTooltip title={title} tips={tips} />
          {title}
        </Col>
        <div style={{ minWidth: '6.5rem' }}>{location}</div>
        <div className="ms-4 flex-grow-1">{documentDetails}</div>
        <div style={{ minWidth: '5rem', marginRight: '1rem' }}>
          {onQtyChange ? (
            <QuantitySelect
              value={qty ?? 1}
              onChange={(value) => onQtyChange(Number(value))}
              options={quantityOptions}
              disabled={qtyDisabled || readOnly}
            />
          ) : null}
        </div>
      </div>
      <Collapse in={checked}>
        <div>
          {!readOnly && (
            <div
              className="d-flex gap-1 align-items-center"
              style={{ margin: '-8px 0 1rem 90px', height: 'auto', paddingLeft: '2.1rem' }}
            >
              {additionalMessage}
            </div>
          )}
        </div>
      </Collapse>
    </div>
  );
};

export default ExcludableDocumentRow;
